import { useMemo } from 'react';
import { pick } from 'lodash/fp';
import { LabelOrigin, LabelValueDetails, TimeSignal } from 'graphql/types';
import { CustomLabel } from 'modules/timesheet-labels/labelSchema';
import {
  useIsSmartSuggestionSettingEnabled,
  determineLabelAcceptedBy
} from 'modules/timesheet-labels/hooks';

export const picker = pick(['idValue', 'numericValue', 'stringValue']);

export const useTimeSignalCustomLabels = (
  timeSignal: TimeSignal,
  labels: CustomLabel[]
): CustomLabel[] => {
  const labelValues = useMemo(
    () => (timeSignal?.labelValues ?? []) as LabelValueDetails[],
    [timeSignal?.labelValues]
  );
  const isSmartSuggestionEnabled = useIsSmartSuggestionSettingEnabled();
  return useMemo(
    () =>
      (labelValues || [])
        .filter((label) => label.label.origin === LabelOrigin.User)
        .map((labelValue: LabelValueDetails) => {
          const label = (labels ?? []).find(
            (label) => labelValue.label.id == label.id
          );
          return {
            ...(label ?? labelValue.label),
            value: labelValue?.value ? picker(labelValue.value) : null,
            valueSource: labelValue.valueSource,
            acceptedBy: determineLabelAcceptedBy(
              labelValue.valueSource,
              labelValue.acceptedBy,
              isSmartSuggestionEnabled
            )
          };
        }),
    [labelValues, labels, isSmartSuggestionEnabled]
  );
};
